import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DxHtmlEditorComponent, DxValidatorComponent } from 'devextreme-angular';
import { FONT_SIZES } from 'src/app/constants/font-sizes';
import { FONT_FAMILIES } from 'src/app/constants/fonts';
import { HEADER_LEVELS } from 'src/app/constants/header-levels';
import { LINE_HEIGHTS } from 'src/app/constants/line-heights';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { DxHtmlEditorTypes } from 'devextreme-angular/ui/html-editor';

@Component({
  selector: 'app-expandable-text-editor',
  standalone: false,
  templateUrl: './expandable-text-editor.component.html',
  styleUrl: './expandable-text-editor.component.scss',
})
export class ExpandableTextEditorComponent {
  @Input() value: string | null = null;
  @Output() valueChange = new EventEmitter<string>();

  @Input() readOnly: boolean = false;

  @Input() fontFamily: string | null = null;
  @Input() fontSize: string | null = null;

  @Input() fontFamilies: string[] = FONT_FAMILIES;
  @Input() lineHeights: string[] = LINE_HEIGHTS;
  @Input() headerLevels: any[] = HEADER_LEVELS;
  @Input() fontSizes: string[] = FONT_SIZES;

  @Input() collapsedRows: number = 6;

  @Input() isExpanded: boolean = false;
  @Output() isExpandedChange = new EventEmitter<boolean>();

  @Input() placeholder: string = '';

  @Input() required = false;
  
  clearButtonOptions = {
    icon: 'clearformat',
    type: 'danger',
    stylingMode: 'text',
    onClick: () => this.clearFormatting(),
  };
  isInvalid = false;

  @ViewChild('htmlEditor', { static: false }) 
  htmlEditor!: DxHtmlEditorComponent;  

  @ViewChild(DxValidatorComponent)
  validator!: DxValidatorComponent;

  sizeItemOptions: any = {};
  fontItemOptions: any = {};

  ngOnInit(): void {
    if (this.isEmptyValue()) {
      this.sizeItemOptions = { value: this.fontSize };
      this.fontItemOptions = { value: this.fontFamily };
    }
  }

  public validate(): boolean {
    if (!this.required) {
      return true;
    }

    const isEmpty = !this.value ||
      this.value.replace(/<[^>]*>/g, '').trim().length === 0;

    this.isInvalid = isEmpty;
    return !isEmpty;
  }

  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
    this.isExpandedChange.next(this.isExpanded);
  }

  onValueChange(value: string) {
    this.value = value;
    this.valueChange.emit(value);

    if (this.required) {
      this.validate();
    }
  }

  clearFormatting() {
    const editor  = this.htmlEditor?.instance as any;

    const selection = editor?.getSelection?.();
    if (selection?.length > 0) {
      editor.formatText(selection.index, selection.length, {
        background: 'transparent',
        color: 'black',
      });
    }
  }

  private isEmptyValue(): boolean {
    return !this.value || this.value.replace(/<[^>]*>/g, '').trim().length === 0;
  }

  onEditorContentReady(e: DxHtmlEditorTypes.ContentReadyEvent): void {
    const quill = e.component.getQuillInstance();

    if (!quill || this.readOnly || !this.isEmptyValue()) return;
    if (!this.fontFamily && !this.fontSize) return;

    quill.setSelection(0, 0, 'silent');
    if (this.fontFamily) quill.format('font', this.fontFamily, 'silent');
    if (this.fontSize)   quill.format('size', this.fontSize, 'silent');
  }
}
